/* unplugin-vue-components disabled */import script from "./race-awards.vue?vue&type=script&lang=jsx"
export * from "./race-awards.vue?vue&type=script&lang=jsx"

import "./race-awards.vue?vue&type=style&index=0&id=1bcb853a&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcb853a"]])

export default __exports__